import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import { useIntl } from 'react-intl';
import messages from './messages';
import schema from './schema';
import View from './View';
import BlockImageInput from '../../helpers/BlockImageInput/BlockImageInput';

const Edit = (props: any) => {
  const intl = useIntl();
  const {
    onChangeBlock,
    data,
    block,
    selected,
    navRoot,
    contentType,
    blocksErrors,
  } = props;
  const blockSchema = schema({ ...props, intl });

  const imageSlot = ({ fieldId, index, value, element }: any) => {
    if (fieldId === 'header_image') {
      return (
        <BlockImageInput
          id="header_image"
          block={block}
          value={value}
          imageSize="great"
          variant="strip"
          description={intl.formatMessage(messages.headerImage)}
          onChange={(next) =>
            onChangeBlock(block, { ...data, header_image: next })
          }
        >
          {element}
        </BlockImageInput>
      );
    }
    if (fieldId === 'items' && typeof index === 'number') {
      return (
        <BlockImageInput
          id={`items-${index}-image`}
          block={block}
          value={value}
          imageSize="preview"
          variant="tile"
          hideLinkPicker
          onChange={(next) => {
            const items = [...(data.items || [])];
            items[index] = { ...items[index], image: next };
            onChangeBlock(block, { ...data, items });
          }}
        >
          {element}
        </BlockImageInput>
      );
    }
    return undefined;
  };

  return (
    <>
      <View {...props} isEditMode imageSlot={imageSlot} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={blockSchema}
          title={blockSchema.title}
          onChangeField={(id: string, value: any) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          onChangeBlock={onChangeBlock}
          formData={data}
          block={block}
          navRoot={navRoot}
          contentType={contentType}
          errors={blocksErrors}
        />
      </SidebarPortal>
    </>
  );
};

export default Edit;
